<template>
	<!-- 3期 https://7jzb8s.axshare.com -->
	<div id="app">
		<transition name="van-fade" mode="out-in"><router-view /></transition>
	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	data() {
		return {
			timer: null,
			isFirstPing: true,
			errorCount: 0
		};
	},
	created() {
		this.getProvince();
	},
	computed: {
		...mapState({
			localGuid(state) {
				return state.user.localGuid;
			}
		})
	},
	watch: {
		localGuid: {
			handler(val) {
				if (val) {
					// this.ping();
				} else if (this.timer) {
					clearTimeout(this.timer);
					this.timer = null;
				}
			},
			immediate: true
		}
	},
	methods: {
		ping() {
			if (this.localGuid) {
				if (process.env.NODE_ENV === 'development') {
					// 如果是开发环境，就不去执行ping
					return;
				}
				this.$api
					.ping({ guid: this.localGuid })
					.then(res => {
						this.errorCount > 0 && (this.errorCount = 0);
						if (res.code === 0) {
							this.timer = setTimeout(() => {
								this.ping();
							}, 5000);
						} else {
							this.$util.showError(this.isFirstPing ? '登录信息失效，请重新登录' : res.msg);
							if (this.timer) {
								clearTimeout(this.timer);
								this.timer = null;
							}
							this.$store.dispatch('user/logout');
						}
						this.isFirstPing && (this.isFirstPing = false);
					})
					.catch(err => {
						console.error(err);
						this.errorCount += 1;
						if (this.errorCount > 2) {
							this.$util.showError('登录异常，请重新登录');
							if (this.timer) {
								clearTimeout(this.timer);
								this.timer = null;
							}
							this.$store.dispatch('user/logout');
						} else {
							// this.timer = setTimeout(() => {
							//     this.ping();
							// }, 5000);
						}
					});
			}
		},
		// 获取当前加盟商的省份code
		getProvince() {
			this.$api.getCurrentShopProvince().then(res => {
				this.$store.dispatch('shop/setCurrentProvince', res.data);
			});
		}
	}
};
</script>

<style lang="scss">
// 13530304041
// 123456
//墨绿  #333
.mo .header_menu {
	background-color: #005270 !important;
}

.mo .header_menu_title ul li.head-nav-link {
	background-color: #005270 !important;
}

.mo .footer_div {
	background-color: #005270 !important;
}

.mo .header_zhong p {
	color: #005270 !important;
}

//蓝色 #006cb5
.lan .header_menu {
	background-color: #006cb5 !important;
}

.lan .header_menu_title ul li.head-nav-link {
	background-color: #004d82 !important;
}

.lan .footer_div {
	background-color: #006cb5 !important;
}

.lan .header_zhong p {
	color: #006cb5 !important;
}

//草绿 #029b7c
.green .header_menu {
	background-color: #029b7c !important;
}

.green .header_menu_title ul li.head-nav-link {
	background-color: #236700 !important;
}

.green .footer_div {
	background-color: #029b7c !important;
}

.green .header_zhong p {
	color: #029b7c !important;
}

//草青色 #68b93e
.qing .header_menu {
	background-color: #68b93e !important;
}

.qing .header_menu_title ul li.head-nav-link {
	background-color: #319000 !important;
}

.qing .footer_div {
	background-color: #68b93e !important;
}

.qing .header_zhong p {
	color: #68b93e !important;
}

//橙色 #f7a322
.orange .header_menu {
	background-color: #f7a322 !important;
}

.orange .header_menu_title ul li.head-nav-link {
	background-color: #b56e00 !important;
}

.orange .footer_div {
	background-color: #f7a322 !important;
}

.orange .header_zhong p {
	color: #f7a322 !important;
}

//红色 #d1502c
.red .header_menu {
	background-color: #d1502c !important;
}

.red .header_menu_title ul li.head-nav-link {
	background-color: #881f02 !important;
}

.red .footer_div {
	background-color: #d1502c !important;
}

.red .header_zhong p {
	color: #d1502c !important;
}
</style>
